import { SyntheticEvent } from 'react'
import i18next from 'i18next'
import { Box } from '@mui/material'

import { Tab, TabPanel, Tabs } from '@components/Tabs'

import { VISIBLE_HIDDEN, WINDOW_MODEL_TYPE } from '@constants'

import { WindowConfig } from './Config/WindowConfig'
import { Sections } from './Section/Sections'
import { VariablesWrapper } from './Variables/VariablesWrapper'

export const windowMainTabs = [
  {
    modelType: WINDOW_MODEL_TYPE.SECTIONS,
    label: i18next.t('window.tabs.sections'),
    component: <Sections />,
  },
  {
    modelType: WINDOW_MODEL_TYPE.VARIABLES,
    label: i18next.t('window.tabs.variables'),
    component: <VariablesWrapper />,
  },
  {
    modelType: WINDOW_MODEL_TYPE.CONFIG,
    label: i18next.t('window.tabs.config'),
    component: <WindowConfig />,
  },
]

type MainTabsProps = {
  currentTab: number
  handleTabChange: (event: SyntheticEvent, tabIndex: number) => void
}

export const MainTabs = ({ currentTab, handleTabChange }: MainTabsProps) => (
  <Box
    sx={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    }}
  >
    <Box sx={{ borderBottom: 1, borderColor: 'divider', flexShrink: '0' }}>
      <Tabs value={currentTab} onChange={handleTabChange}>
        {windowMainTabs.map(tab => (
          <Tab key={tab.modelType} label={tab.label} />
        ))}
      </Tabs>
    </Box>
    <Box sx={{ flex: '1', overflow: 'auto' }}>
      {windowMainTabs.map((tab, index) => (
        <TabPanel
          key={tab.modelType}
          index={index}
          sx={{ ...(currentTab !== index && VISIBLE_HIDDEN) }}
          value={currentTab}
        >
          {tab.component}
        </TabPanel>
      ))}
    </Box>
  </Box>
)
